var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('jdi-content',{attrs:{"title":"Text Provider"}},[_c('h2',[_vm._v("The Text Provider")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }